import React, { FunctionComponent } from 'react';
import {
  Tooltip,
  TooltipProps,
  TooltipReference,
  TooltipInitialState,
  useTooltipState,
} from 'reakit/Tooltip';
import cx from 'classnames';
import { motion, AnimatePresence, Transition } from 'framer-motion';

type ArrowPlacement =
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'top'
  | 'top-start'
  | 'top-end';

export interface CKTooltipProps extends TooltipProps {
  transition?: Transition;
  arrowPlacement?: ArrowPlacement;
  tooltip: React.ReactElement;
  options?: TooltipInitialState;
  children: React.ReactElement;
}

export const CKTooltip: FunctionComponent<CKTooltipProps> = ({
  children,
  transition = { ease: 'circOut', duration: 0.2 },
  arrowPlacement = 'bottom',
  tooltip,
  options,
}) => {
  const tooltipClass = cx('ck-tooltip', `ck-tooltip--${arrowPlacement}`);
  const tooltipState = useTooltipState(options);

  return (
    <React.Fragment>
      <TooltipReference
        {...tooltipState}
        // @ts-ignore
        ref={children.ref}
        {...children.props}
      >
        {referenceProps => React.cloneElement(children, referenceProps)}
      </TooltipReference>
      <Tooltip {...tooltipState}>
        {props =>
          tooltipState.visible && (
            <div {...props}>
              <AnimatePresence>
                <motion.div
                  transition={transition}
                  className={tooltipClass}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  {tooltip}
                </motion.div>
              </AnimatePresence>
            </div>
          )
        }
      </Tooltip>
    </React.Fragment>
  );
};
